import IComponent from "components/commons/IComponent";
import { dataProcessFunctions } from "./dataProcessFunctions";
import "./DetailPanels.scoped.css";
class S1Report extends IComponent {
  constructor(props) {
    super(props);
    console.log("S1Report props", props);
    this.state = {
      Stage1StudyReport: [
        {
          alias: "Feature Ref. No.",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "Inspected On",
          field: "S1_DATE",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Weather",
          field: "S1_WEATHER",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "District",
          field: "DISTRICT",
          value: "",
          childObjKey: "RelatedReport",
        },
        {
          alias: "",
          field: "URL",
          value: "",
          isImg: true,
          childObjKey: "S1Report",
        },
        {
          alias: "Section No.",
          field: "",
          value: "1-1",
        },
        {
          alias: "Height (m)",
          field: "HEIGHT",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Type of Toe Facility",
          field: "TOE_TYPE",
          value: "",
        },
        {
          alias: "Distance from Toe (m)",
          field: "TOE_DIST",
          value: "",
        },
        {
          alias: "Type of Crest Facility",
          field: "CREST_TYPE",
          value: "",
        },
        {
          alias: "Distance from Crest (m)",
          field: "CREST_DIST",
          value: "",
        },
        {
          alias: "Consequence Category",
          field: "CATEGE",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Engineering Judgement",
          field: "ENG_JUD",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Section No.",
          field: "",
          value: "2-2",
        },
        {
          alias: "Type of Toe Facility",
          field: "DC_TOE_STRUT_S2",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Distance from Toe (m)",
          field: "DC_TOE_DIST_S2",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Type of Crest Facility",
          field: "DC_CREST_STRUT_S2",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Distance from Crest (m)",
          field: "DC_CREST_DIST_S2",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Consequence Category",
          field: "CATEGE",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Engineering Judgement",
          field: "ENG_JUD",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Sign of Seepage",
          field: ["SEEPAGE", "WSEEPAGE"],
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Criterion A satisfied",
          field: "S1_CRITERIA_A",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Sign of Distress",
          field: ["SIGN_DISTRESS", "WF_SIGN_DISTRESS"],
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Criterion D satisfied",
          field: "S1_CRITERIA_D",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Non-routine maintenance required",
          field: "S1_NON_ROUT_MAINT",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Note",
          field: "S1_MAINT_NOTES",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Masonry wall/Masonry facing",
          field: "S1_MASONRY_WALL",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Note",
          field: "S1_MASONRY_NOTES",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Consequence category (for critical section)",
          field: "CATEGE",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Observations",
          field: "REMARK",
          value: "",
        },
        {
          alias: "Emergency Action Required",
          field: "S1_EMERGENCY_ACT",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Action By",
          field: "MAINT_TYPE",
          value: "",
          childObjKey: "RelatedReport",
          format: (mResult) =>
            mResult.S1Report.S1_EMERGENCY_ACT === "Y"
              ? mResult.RelatedReport.MAINT_TYPE
              : "N/A",
        },
      ],
      ActionToInitPREWorks: [
        {
          alias: "Criterion A/Criterion D",
          field: ["S1_CRITERIA_A", "S1_CRITERIA_D"],
          value: "",
          childObjKey: "S1Report",
          format: (mResult) =>
            mResult.S1Report.S1_CRITERIA_A === "Y" ||
            mResult.S1Report.S1_CRITERIA_D === "Y"
              ? "Y"
              : "N/A",
        },
        {
          alias: "Action By",
          field: "S1_ACT_INIT_WAGENCY",
          value: "",
          childObjKey: "S1Report",
          format: (mResult) =>
            mResult.S1Report.S1_CRITERIA_A === "Y" ||
            mResult.S1Report.S1_CRITERIA_D === "Y"
              ? mResult.S1Report.S1_ACT_INIT_WAGENCY.toUpperCase() === "BD"
                ? "Private"
                : mResult.S1Report.S1_ACT_INIT_WAGENCY.toUpperCase() === "GOVT"
                ? "Government"
                : "N/A"
              : "N/A",
        },
        {
          alias: "Further Study",
          field: "S1_ACT_INIT_STUDY",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Action By",
          field: "MAINT_TYPE",
          value: "",
          childObjKey: "RelatedReport",
          format: (mResult) =>
            mResult.S1Report.S1_ACT_INIT_STUDY === "Y"
              ? mResult.RelatedReport.MAINT_TYPE
              : "N/A",
        },
      ],
      OtherExternalActs: [
        {
          alias: "Check / repair Services",
          field: "S1_CHECK_REP_SER",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Action By",
          field: "S1_CHECK_REP_SAGENCY",
          value: "",
          childObjKey: "S1Report",
          format: (mResult) =>
            mResult.S1Report.S1_CHECK_REP_SER === "Y"
              ? mResult.S1Report.S1_CHECK_REP_SAGENCY
              : "N/A",
        },
        {
          alias: "Non-routine Maintenance",
          field: "S1_NON_ROUT_MAINT",
          value: "",
          childObjKey: "S1Report",
        },
        {
          alias: "Action By",
          field: "MAINT_TYPE",
          value: "",
          childObjKey: "RelatedReport",
          format: (mResult) =>
            mResult.S1Report.S1_NON_ROUT_MAINT === "Y"
              ? mResult.RelatedReport.MAINT_TYPE
              : "N/A",
        },
      ],
    };
  }
  componentDidMount() {
    this.props.isShowTabCallback(true);
    let dataProcessClassObj = new dataProcessFunctions();
    let tmpStage1StudyReport = this.state.Stage1StudyReport;
    tmpStage1StudyReport = dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
      tmpStage1StudyReport,
      this.props.attributes,
      ["S1Report", "RelatedReport"]
    );
    let tmpActionToInitPREWorks = this.state.ActionToInitPREWorks;
    tmpActionToInitPREWorks = dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
      tmpActionToInitPREWorks,
      this.props.attributes,
      ["S1Report", "RelatedReport"]
    );
    let tmpOtherExternalActs = this.state.OtherExternalActs;
    tmpOtherExternalActs = dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
      tmpOtherExternalActs,
      this.props.attributes,
      ["S1Report", "RelatedReport"]
    );
    this.setState({
      Stage1StudyReport: tmpStage1StudyReport,
      ActionToInitPREWorks: tmpActionToInitPREWorks,
      OtherExternalActs: tmpOtherExternalActs,
    });
  }
  render() {
    return (
      <div>
        <div className="SubPanelTitle">Basic Information</div>
        <table className="ResultInfoTable">
          <tbody>
            {this.state.Stage1StudyReport.map((i, j) => {
              return (
                <tr key={`stage1StudyReport_` + j} className="ResultInfoRow">
                  <td className="ResultInfoRowHead">{i.alias}</td>
                  <td className="ResultInfoRowValue">
                    {"isImg" in i ? (
                      <a href={i.value} target="#">
                        <img style={{ width: "100%" }} src={i.value} alt="" />
                      </a>
                    ) : (
                      <span dangerouslySetInnerHTML={{ __html: i.value }} />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="SubPanelTitle">Action To Initiate Preventive Works</div>
        <table className="ResultInfoTable">
          <tbody>
            {this.state.ActionToInitPREWorks.map((i, j) => {
              return (
                <tr key={`actionToInitPREWorks_` + j} className="ResultInfoRow">
                  <td className="ResultInfoRowHead">{i.alias}</td>
                  <td className="ResultInfoRowValue">
                    {i.value && i.value.replace("<br/>", " / ")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="SubPanelTitle">Other External Action</div>
        <table className="ResultInfoTable">
          <tbody>
            {this.state.OtherExternalActs.map((i, j) => {
              return (
                <tr key={`otherExternalActs_` + j} className="ResultInfoRow">
                  <td className="ResultInfoRowHead">{i.alias}</td>
                  <td className="ResultInfoRowValue">{i.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
export default S1Report;
